<template>
  <CPopover
    v-if="child && child.tooltip"
    :content="child.tooltip"
    placement="top"
    :trigger="['hover', 'focus']"
  >
    <template #toggler="{ on }">
      <ChildWrapper :open="open" :child="child" v-on="on" />
    </template>
  </CPopover>
  <ChildWrapper v-else-if="child" :open="open" :child="child" />
</template>

<script lang="ts">
import { Children, Children2 } from "@/types/jsonTypes";
import { defineComponent, PropType } from "vue";
import ChildWrapper from "@/components/ChildWrapper.vue";

export default defineComponent({
  name: "ToolTipWrapper",
  components: {
    ChildWrapper,
  },
  props: {
    child: {
      type: Object as PropType<Children | Children2>,
    },
    open: {
      type: Boolean,
    },
  },
});
</script>

<style scoped></style>
